import * as React from 'react';
export default class InputElement extends React.Component {
    constructor() {
        super(...arguments);
        this.saveRef = (ele) => {
            const { ref: childRef } = this.props.children;
            if (typeof childRef === 'function') {
                childRef(ele);
            }
        };
    }
    render() {
        return React.cloneElement(this.props.children, Object.assign(Object.assign({}, this.props), { ref: this.saveRef }), null);
    }
}
